export const buttonsTranslatePaths = {
  save: 'buttons.save',
  delete: 'buttons.delete',
};
